// Lógica pura de "stock" (artículos), sin Firestore ni Express ni React.

export function enriquecerArticulo(articulo, proveedoresPorId = {}) {
  const proveedor = proveedoresPorId[String(articulo.proveedor)];

  // Antes esto rompía (TypeError) si el artículo tenía codigoProveedor
  // pero el proveedor ya no existía en la colección de proveedores.
  const detalleEtiqueta =
    articulo.codigoProveedor && proveedor
      ? `(${articulo.codigoProveedor} - ${proveedor.nombre})`
      : null;

  const etiqueta = `${articulo.descripcion || ""} ${detalleEtiqueta || ""} ${
    articulo.marca || ""
  }`.replace(/\s+/g, " ").trim();

  return {
    ...articulo,
    nombreProveedor: proveedor
      ? `${proveedor.id} - ${proveedor.nombre} (${proveedor.cuit})`
      : "",
    label: etiqueta,
  };
}

export function enriquecerArticulos(articulos, proveedores = []) {
  const proveedoresPorId = {};
  proveedores.forEach((p) => {
    proveedoresPorId[p.id] = p;
  });
  return articulos.map((a) => enriquecerArticulo(a, proveedoresPorId));
}

function itemsDelDeposito(dep) {
  let st = dep && dep.stock;
  if (typeof st === "string") {
    try {
      st = JSON.parse(st);
    } catch {
      st = [];
    }
  }
  return Array.isArray(st) ? st : [];
}

// Cuánto hay de un artículo en cada depósito (Igna, 22/10: «que dijera en qué
// depósito hay cuántos»). Sólo los depósitos con algo; el más lleno primero.
export function porDeposito(articuloId, depositos = []) {
  const id = String(articuloId ?? "");
  const out = [];
  (depositos || []).forEach((dep) => {
    const cantidad = itemsDelDeposito(dep)
      .filter((it) => String(it && it.id) === id)
      .reduce((s, it) => s + (Number(it.cantidad) || 0), 0);
    if (cantidad) {
      out.push({ id: dep.id, nombre: dep.nombre || String(dep.id), cantidad });
    }
  });
  return out.sort((a, b) => b.cantidad - a.cantidad);
}

// El renglón de la ficha: «OFICINA DE NICO: 11 · TALLER TRACTORES: 3».
export function textoPorDeposito(articuloId, depositos = []) {
  return porDeposito(articuloId, depositos)
    .map((d) => `${d.nombre}: ${d.cantidad}`)
    .join(" · ");
}

export function filtrarPorTipo(articulos, tipo) {
  return articulos.filter(
    (a) => (a.tipo || "").toLowerCase() === tipo.toLowerCase()
  );
}

export const getHerramientas = (articulos) =>
  filtrarPorTipo(articulos, "herramienta");
